import React from 'react';
/** Provides access to the Analytics reporter object */
export var AnalyticsContext = React.createContext(null);
